import { baseUrl } from "../../../../lib/routes/baseUrl";
import buildUrl from "../../../../lib/utils/buildUrl";

export const getFetchPaymentRoute = (paymentId: number | string) =>
  buildUrl({
    url: `${baseUrl}/payments-api/payments/pageable-search`,
    searchParams: { paymentIds: [paymentId] },
  });

export const getFetchPaymentAdjustmentsRoute = (props: {
  agreementId: number;
  adjustmentTypeId?: number[];
  parentTransactionId: number;
}) =>
  buildUrl({
    url: `${baseUrl}/billing-api/adj`,
    searchParams: { ...props },
  });

export const getFetchAgreementBillsRoute = (props: {
  agreementId: number;
  billTypeId: number;
  payStatusIds: number[];
  billStatusIds: number[];
}) =>
  buildUrl({
    url: `${baseUrl}/billing-api/bills/search`,
    searchParams: { ...props },
  });

export const getFetchAgreementServicesRoute = (props: {
  agreementId: number;
  includeFutureDates: boolean;
  includePastDates: boolean;
  extendedInfo: boolean;
  extendedOfferingInfo: boolean;
  withChars: boolean;
  serviceStatusId: number[];
}) =>
  buildUrl({
    url: `${baseUrl}/services-api/services/search`,
    searchParams: { ...props },
  });
